import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCube, faCogs } from "@fortawesome/free-solid-svg-icons";
import { FEATURES } from "./extractFeaturesList.js";

const scmMenu = [
  {
    label: "Packages",
    icon: <FontAwesomeIcon icon={faCube} />,
    cName: "nav-text",
    children: [
      { label: "Find package", to: "find-package", feature: [FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE] },
      { label: "Create package", to: "create-package", feature: [FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE] },
      { label: "Manage Dependencies", to: "manage-dependencies", feature: [FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE] },
    ]
  },
  {
    label: "Deployment",
    icon: <FontAwesomeIcon icon={faCogs} />,
    cName: "nav-text",
    children: [
      { label: "Find Package for Deploy", to: "find-package-deployment", feature: [FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT] },
      { label: "Track Deployment", to: "track-deployment", feature: [FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT] }
    ]
  }
];

export default scmMenu;
